// ======================================================================
// File: IndentKpiBar.jsx
// Module: PPE → Procurement → Indent
//
// Purpose:
// - KPI summary strip
// - UI identical to ProcessKpiBar
// - Frontend-only calculation
//
// ======================================================================

import React from "react";
import INDENT_STATUS from "../enums/indentStatus";

export default function IndentKpiBar({ rows = [] }) {
  const total = rows.length;

  const count = (status) =>
    rows.filter((r) => r.status === status).length;

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: 16,
        marginBottom: 20,
      }}
    >
      <KpiCard
        label="Total"
        value={total}
        color="#0f766e"
      />

      <KpiCard
        label="Draft"
        value={count(INDENT_STATUS.DRAFT)}
        color="#64748b"
      />

      <KpiCard
        label="Submitted"
        value={count(INDENT_STATUS.SUBMITTED)}
        color="#0284c7"
      />

      <KpiCard
        label="Approved"
        value={count(INDENT_STATUS.APPROVED)}
        color="#16a34a"
      />

      <KpiCard
        label="Closed"
        value={count(INDENT_STATUS.CLOSED)}
        color="#7c2d12"
      />
    </div>
  );
}

// ----------------------------------------------------------------------

function KpiCard({ label, value, color }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: "14px 18px",
        borderLeft: `6px solid ${color}`,
        boxShadow:
          "0 1px 2px rgba(0,0,0,0.08)",
      }}
    >
      <div
        style={{
          fontSize: 13,
          color: "#6b7280",
          marginBottom: 4,
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: 22,
          fontWeight: 600,
          color: "#111827",
        }}
      >
        {value}
      </div>
    </div>
  );
}
